import { Tooltip } from "primereact/tooltip";
import { useSecureContext } from "../contexts/SecureContext";
import Show from "./Show";

export type TextColors = "primary" | "secondary" | "white" | "0" | "50" | "100" | "200" | "300" | "400" | "500" | "600" | "700" | "800" | "900" | "green-400" | "green-500" | "red-500" | "attention";
export type TextSizes = "xs" | "sm" | "base" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl";
export type TextWeights = "light" | "normal" | "medium" | "semibold" | "bold";

interface ITextProps {
    color?: TextColors;
    size?: TextSizes;
    fontWeight?: TextWeights;
    children: React.ReactNode;
    center?: boolean;
    className?: string;
    onClick?: () => void;
    showEllipsis?: boolean;
}

export default function Text({ children, center, fontWeight = "normal", color = "500", size = "base", onClick, className = "", showEllipsis }: ITextProps) {
    const secureContext = useSecureContext();
    const spanId = `span-${Math.random().toString(36).substr(2, 9)}`;
    return (
        <>
            <Show when={!!showEllipsis}>
                <Tooltip target={`#${spanId}`}>{children}</Tooltip>
            </Show>

            <span
                className={`text-${color} font-${fontWeight} text-${size} ${onClick ? "cursor-pointer" : ""} ${center ? "block text-center w-full" : ""} ${className} ${showEllipsis ? "overflow-hidden text-overflow-ellipsis inline-block" : ""}`}
                onClick={onClick}
                id={spanId}
                style={{ width: showEllipsis ? "20rem" : "auto" }}
            >
                {children?.toString()?.endsWith("%") ? !secureContext.isSecure ? children : "**" : children}
            </span>
        </>
    );
}
